import { FileFilterKey, FileFiltersMap } from '../models/FileFilters';
import { CustomFilterType } from '../models/Filters';
import { LocationFilterKey, LocationFiltersMap, } from '../models/LocationFilters';
export function getFilterFunctionFromCustomPivot(customPivot, tagMap, getTagIdByTagValue) {
    switch (customPivot.customFilterType) {
        case CustomFilterType.FileType:
            var fileFilterKey = Object.values(FileFilterKey).find(function (key) { return key === customPivot.customFilterKey; });
            if (fileFilterKey && FileFiltersMap.has(fileFilterKey)) {
                return FileFiltersMap.get(fileFilterKey);
            }
        case CustomFilterType.Location:
            var locationFilterKey = Object.values(LocationFilterKey).find(function (key) { return key === customPivot.customFilterKey; });
            if (locationFilterKey &&
                LocationFiltersMap.has(locationFilterKey)) {
                return LocationFiltersMap.get(locationFilterKey);
            }
        case CustomFilterType.OwnedBy:
            return function (doc) {
                return !!doc.creatorUpn &&
                    doc.creatorUpn.toLowerCase() ===
                        customPivot.customFilterKey.toLocaleLowerCase();
            };
        case CustomFilterType.SharedBy:
            return function (doc) {
                return (!!doc.sharedByEmail &&
                    doc.sharedByEmail.toLowerCase() ===
                        customPivot.customFilterKey.toLocaleLowerCase()) ||
                    (!!doc.sharedByFullUsername &&
                        doc.sharedByFullUsername
                            .toLowerCase()
                            .indexOf(customPivot.customFilterKey.toLocaleLowerCase()) >= 0) ||
                    (!!doc.sharedByUsername &&
                        doc.sharedByUsername
                            .toLowerCase()
                            .indexOf(customPivot.customFilterKey.toLocaleLowerCase()) >= 0);
            };
        case CustomFilterType.Tag:
            var tagId = void 0;
            if (!tagMap ||
                !getTagIdByTagValue ||
                !(tagId = getTagIdByTagValue(customPivot.customFilterKey)) ||
                !tagMap.has(tagId)) {
                return function () { return false; };
            }
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var docIdsSet_1 = tagMap.get(tagId)[1];
            return function (doc) { return docIdsSet_1.has(doc.id); };
        case CustomFilterType.Tagv2:
            if (!tagMap ||
                !customPivot.customFilterKey ||
                !tagMap.has(customPivot.customFilterKey)) {
                return function () { return false; };
            }
            return function (doc) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return tagMap.get(customPivot.customFilterKey)[1].has(doc.id);
            };
    }
    return function () { return true; };
}
//# sourceMappingURL=getFilterFunctionFromCustomPivot.js.map